<template>
  <div class="withdraw_wrap">
    <div class="red_top_bg">
      <div class="back_left" @click="$router.push('/user')"></div>
      <div class="big_tit">{{$t('Identity Authentication')}}</div>
    </div>
    <div class="wrap_box wrap1">
      <!-- Success -->
      <div style="text-align: center;" v-if="is_auth == 1">
        <div class="group2">
          <img class="img1" src="../images/user/smile.png">
        </div>
        <div class="show_yes">
          {{ $t('user.auth_yes') }}
        </div>
      </div>

      <!-- Reject -->
      <div style="text-align: center;" v-if="is_auth == 2">
        <div class="group2">
          <img class="img1" src="../images/user/nav/bz-y.png">
        </div>
        <div class="show_yes" style="color: #FF9900;">
          {{ $t('Your identity verification failed, please provide real and valid identity information again.') }}
        </div>
        <div class="mt-30">
          <van-button @click="handleResubmit" type="primary" size="normal" color="#76b900" style="width: 200px;">{{$t('Resubmit')}}</van-button>
        </div>
      </div>

      <!-- Wait -->
      <div style="text-align: center;" v-if="is_auth == 3">
        <div class="group2">
          <img class="img1" src="../images/user/smile.png">
        </div>
        <div class="show_yes">
          {{ $t('Your identity verification is under review, expected in 5-30 minutes...') }}
        </div>
      </div>

      <!-- Not yet -->
      <div v-if="is_auth == 0" style="margin-top: 45px;">
        <van-field v-model="surname" :label="$t('Surname')" :placeholder="$t('Please enter your surname')" label-width="120"/>
        <van-field v-model="names" :label="$t('Names')" :placeholder="$t('Please enter your names')" label-width="120"/>
        <van-field v-model="identityNumber" :label="$t('Identity Number')" :placeholder="$t('Please enter your identity number')" label-width="120"/>
        <van-field
                v-model="birthday"
                :label="$t('Date of Birth')"
                :placeholder="$t('Please select your date of birth')"
                readonly
                @click="showPicker = true"
                label-width="120"
        />
        <van-popup v-model="showPicker" position="bottom">
          <van-datetime-picker
                  v-model="birthdayInPicker"
                  type="date"
                  :title="$t('Select birth date')"
                  :min-date="minDate"
                  :max-date="maxDate"
                  @confirm="onConfirm"
                  @cancel="showPicker = false"
                  :confirm-button-text = "$t('Confirm')"
                  :cancel-button-text = "$t('Cancel')"
          />
        </van-popup>

        <div class="group3 flex-col">
          <div class="layer1 flex-col justify-between">
            <van-uploader multiple :max-count="1" :max-size="5 * 1024 * 1024" @oversize="onOversize" :after-read="afterRead1"
                          :before-read="beforeRead">
              <img
                  class="img1"
                  referrerpolicy="no-referrer"
                  :src="front_img"
                  v-if="front_img"
              />
              <img
                  class="img1"
                  referrerpolicy="no-referrer"
                  src="../images/user/front.png"
                  v-else
              />
            </van-uploader>
            <span class="word4">{{$t('utils.kycfront')}}</span>
          </div>
        </div>
        <div class="group4 flex-col">
          <div class="layer1 flex-col justify-between">
            <van-uploader multiple :max-count="1" :max-size="5 * 1024 * 1024" @oversize="onOversize" :after-read="afterRead2"
                          :before-read="beforeRead">
              <img
                  class="img1"
                  referrerpolicy="no-referrer"
                  :src="back_img"
                  v-if="back_img"
              />
              <img
                  class="img1"
                  referrerpolicy="no-referrer"
                  src="../images/user/back.png"
                  v-else
              />
            </van-uploader>
            <span class="word4">{{$t('utils.kycback')}}</span>
          </div>
        </div>
        <div class="basic_btn" @click="submit">{{$t('utils.submit')}}</div>
        <div style="color: gray;margin-bottom: 30px">
          {{ $t('Valid Id List: ID Book,Driver’s License,Passport.') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Fetch from '../../utils/fetch'
import {
  Popup,
  Icon, Toast,Uploader,
} from 'vant';
import axios from "axios";
import Api from "@/interface";
Vue.use(Uploader).use(Popup).use(Icon);

export default {
  name: "certification",
  data() {
    return {
      data: {},
      is_auth: 3,
      submitStatus:1,
      front_img:'',
      back_img:'',
      showPicker: false,
      surname: "", // 姓氏
      names: "", // 名字
      identityNumber: "", // 身份证号码
      birthday: "", // 出生日期
      birthdayInPicker: new Date(2008, 0, 1),
      minDate: new Date(1900, 0, 1),
      maxDate: new Date(2008, 11, 31),
    };
  },
  created() {
    this.$parent.footer('user', false);
  },
  mounted() {
    this.start();
  },
  methods: {
    start() {
      Fetch('/user/info').then((r) => {
        this.is_auth = r.data.is_auth;
      });
    },
    onConfirm(value) {
      // value 是 Date 对象
      this.birthday = this.formatDate(value);
      this.showPicker = false;
    },
    formatDate(date) {
      const y = date.getFullYear();
      const m = (date.getMonth() + 1).toString().padStart(2, "0");
      const d = date.getDate().toString().padStart(2, "0");
      return `${y}-${m}-${d}`;
    },
    onOversize() {
      this.$toast(this.$t('account.within2megabytes'));
    },
    beforeRead(file) {
      if (file.type !== 'image/jpeg' && file.type !== 'image/jpg' && file.type !== 'image/png') {
        this.$toast(this.$t('account.supportPicture'));
        return false;
      }
      return true;
    },
    afterRead1(file) {
      let formData = new FormData();
      formData.append('language', this.$i18n.locale||"en_us");
      formData.append('file', file.file);
      formData.append('token', localStorage.getItem('token'));
      Toast.loading({
        forbidClick: true,
        duration: 20000
      });
      axios.post(Api.commonUrl+"/api/index/bank_link_upload", formData).then((r) => {
        Toast.clear();
        if (r.data.code === 1) {
          this.front_img = r.data.data;
        } else {
          if (r.data.info) {
            this.$toast(r.data.info);
          } else {
            this.$toast(this.$t('account.uploadFail'));
          }
        }
      });
    },
    afterRead2(file) {
      let formData = new FormData();
      formData.append('language', this.$i18n.locale||"en_us");
      formData.append('file', file.file);
      formData.append('token', localStorage.getItem('token'));
      Toast.loading({
        forbidClick: true,
        duration: 20000
      });
      axios.post(Api.commonUrl+"/api/index/bank_link_upload", formData).then((r) => {
        Toast.clear();
        if (r.data.code === 1) {
          this.back_img = r.data.data;
        } else {
          if (r.data.info) {
            this.$toast(r.data.info);
          } else {
            this.$toast(this.$t('account.uploadFail'));
          }
        }
      });
    },
    // 重新提交
    handleResubmit(){
      this.is_auth = 0
    },
    submit() {
      if(this.submitStatus == 0)
        return false;
      if(!this.surname) {
        this.$toast(this.$t('Please enter your surname'));
        return false;
      }
      if(!this.names) {
        this.$toast(this.$t('Please enter your names'));
        return false;
      }
      if(!this.identityNumber) {
        this.$toast(this.$t('Please enter your identity number'));
        return false;
      }
      if(!this.birthday) {
        this.$toast(this.$t('Please select your date of birth'));
        return false;
      }
      if(!this.front_img){
        this.$toast(this.$t('account.supportPicture'));
        return false;
      }
      if(!this.back_img){
        this.$toast(this.$t('account.supportPicture'));
        return false;
      }
      Fetch('/user/certification_submit', {
        front_img: this.front_img,
        back_img: this.back_img,
        surname: this.surname,
        names: this.names,
        identityNumber: this.identityNumber,
        birthday: this.birthday,
      }).then(() => {
        this.$toast({
          background: '#07c160',
          message: this.$t('account.success')
        });

        if(this.$route.query.redirect){
          this.$router.replace(this.$route.query.redirect+"&money="+this.$route.query.money+"&goodId="+this.$route.query.goodId+"&upid="+this.$route.query.upid)
        }else{
          this.$router.replace('/user')
        }
      });
    },
  }
};
</script>

<style lang="less" scoped>

/deep/ .van-action-sheet__item {
  text-align: left;
}
/deep/ .van-popup--bottom{
  border-radius:0;
  padding-bottom: 15px;
}

.red_top_bg {
  height: 180px;
  background: #76b900;
  border-radius: 0 0 33% 33%;
}
.back_left {
  top: 12px;
}
.big_tit {
  top: 12px;
}
.wrap1 {
  position: absolute;
  top: 30px;
  width: 100%;
  padding: 0 15px;
  box-shadow: none;
  background: none;

  .withdraw_wrap{
    width: 100%;
    background: #ffffff;
    border-radius: 6px;
    padding: 16px 20px;
    margin-top: 10px;
  }
}

.group2{
  padding: 20px 80px 15px;
  margin: 60px auto 0;
  width: 220px;
}

.group3 {
  box-shadow: 3px 6px 18px 0px rgba(0, 0, 0, 0.14);
  background-color: rgba(255, 255, 255, 1);
  border-radius: 15px;
  margin-top: 20px;
  padding: 20px 50px 15px;
}

.group4 {
  box-shadow: 3px 6px 18px 0px rgba(0, 0, 0, 0.14);
  background-color: rgba(255, 255, 255, 1);
  border-radius: 15px;
  margin-top: 20px;
  padding: 20px 50px 15px;
}

.layer1 {

}

.img1 {
  width: 100%;
}

.word4 {
  overflow-wrap: break-word;
  color: #999999;
  font-size: 15px;
  padding: 10px 0 0;
  font-family: PingFang-SC-Heavy;
  text-align: center;
  white-space: nowrap;
  line-height: 21px;
  display: block;
}

.basic_btn{
  margin: 20px auto;
}
.show_yes{
  color: #5e5a5a;
  margin: 20px auto;
  font-size: 18px;
  line-height: 28px;
}
</style>
